import {z} from 'zod'

/** @typedef {z.infer<typeof SpecUnit>} SpecUnit */
export const SpecUnit = z.object({
  id: z.coerce.string(),
  name: z.string(),
  desc: z.string().nullish(),
})
